import React, { FunctionComponent, useEffect, useState } from "react";
import styles from "./css/MyAccount.module.css";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useSelector } from "react-redux";

interface ISidebarProp {
  activeTabs: number;
}

const Sidebar: FunctionComponent<ISidebarProp> = ({ activeTabs }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const cartItems = JSON.parse(localStorage.getItem("cartItems") || "[]");
  const totalQuantity = cartItems.reduce(
    (acc: number, item: { quantity: number }) => acc + item.quantity,
    0
  );

  const [accessToken] = useState(localStorage.getItem("accessToken"));

  const [isAudioBought, setIsAudioBought] = useState(false);

  const reduxStateLanguage = useSelector((state: any) => state.language.value);

  const getTabStyle = (tabIndex: number) => {
    return activeTabs === tabIndex ? { backgroundColor: "#f0f0f0" } : {};
  };

  const getUnderline = (tabIndex: number) => {
    return activeTabs === tabIndex ? (
      <>
        <div className={styles.underline} />
      </>
    ) : (
      <></>
    );
  };

  const handleLogout = async () => {
    // Clear tokens from localStorage (or cookies if you're using those)
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/auth/logout`
      );

      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");

      navigate("/");
    } catch (err) {
      console.error("Logout failed", err);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);
  const fetchOrders = async () => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      if (!accessToken) {
        console.log("No access token found");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/purchases/my-purchases`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      console.log(response);

      // Check if any book has format "audio"
      const hasAudioBook = response.data.some((order) =>
        order.book.formats.some((format) => format.format === "audio")
      );

      setIsAudioBought(hasAudioBook);

      console.log("Contains an audio book:", hasAudioBook);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  const handleMe = async (accessToken: any) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/auth/profile`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      console.log("Me info:", response.data);
    } catch (err) {
      console.error("Login failed", err);
    }
  };

  useEffect(() => {
    handleMe(accessToken);
  }, []);

  const getCurrentTabName = () => {
    switch (activeTabs) {
      case 0:
        return reduxStateLanguage === "RO" ? "Contul meu" : "My account";
      case 1:
        return reduxStateLanguage === "RO" ? "Securitate" : "Security";
      case 2:
        return reduxStateLanguage === "RO" ? "Adrese" : "Addresses";
      case 3:
        return reduxStateLanguage === "RO" ? "Comenzi" : "Orders";
      case 4:
        return reduxStateLanguage === "RO" ? "Player Audio" : "Audio Player";
      default:
        return reduxStateLanguage === "RO" ? "Contul meu" : "My account";
    }
  };

  return (
    <>
      {/* Mobile Dropdown */}
      <div className={styles.mobileMenu}>
        <button
          className={styles.mobileMenuButton}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <MenuIcon />
          <span>{getCurrentTabName()}</span>
          <KeyboardArrowDownIcon
            className={`${styles.arrowIcon} ${
              isMobileMenuOpen ? styles.arrowRotated : ""
            }`}
          />
        </button>

        {isMobileMenuOpen && (
          <div className={styles.mobileMenuDropdown}>
            <Link
              to="/admin/myaccount"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <div
                className={`${styles.mobileMenuItem} ${
                  activeTabs === 0 ? styles.activeTab : ""
                }`}
              >
                {reduxStateLanguage === "RO" ? "Contul meu" : "My account"}
              </div>
            </Link>

            <Link
              to="/admin/password"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <div
                className={`${styles.mobileMenuItem} ${
                  activeTabs === 1 ? styles.activeTab : ""
                }`}
              >
                {reduxStateLanguage === "RO" ? "Securitate" : "Security"}
              </div>
            </Link>

            <Link
              to="/admin/addresses"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <div
                className={`${styles.mobileMenuItem} ${
                  activeTabs === 2 ? styles.activeTab : ""
                }`}
              >
                {reduxStateLanguage === "RO" ? "Adrese" : "Addresses"}
              </div>
            </Link>

            <Link to="/admin/orders" onClick={() => setIsMobileMenuOpen(false)}>
              <div
                className={`${styles.mobileMenuItem} ${
                  activeTabs === 3 ? styles.activeTab : ""
                }`}
              >
                {reduxStateLanguage === "RO" ? "Comenzi" : "Orders"}
              </div>
            </Link>

            {isAudioBought && (
              <Link
                to="/admin/audio_player"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <div
                  className={`${styles.mobileMenuItem} ${
                    activeTabs === 4 ? styles.activeTab : ""
                  }`}
                >
                  {reduxStateLanguage === "RO"
                    ? "Player Audio"
                    : "Audio Player"}
                </div>
              </Link>
            )}

            <button className={styles.logoutButton} onClick={handleLogout}>
              {reduxStateLanguage === "RO" ? "Deconectare" : "Log out"}
            </button>
          </div>
        )}
      </div>

      {/* Desktop Sidebar */}
      <div className={styles.desktopMenu}>
        <div className={styles.productDetails}>
          <Link to="/admin/myaccount">
            <div className={styles.link} style={getTabStyle(0)}>
              <span className={styles.productDescription2}>
                {reduxStateLanguage === "RO" ? "Contul meu" : "My account"}
              </span>
              {getUnderline(0)}
            </div>
          </Link>

          <Link to="/admin/password">
            <div className={styles.link} style={getTabStyle(1)}>
              <span className={styles.productDescription2}>
                {reduxStateLanguage === "RO" ? "Securitate" : "Security"}
              </span>
              {getUnderline(1)}
            </div>
          </Link>
          <Link to="/admin/addresses">
            <div className={styles.link} style={getTabStyle(2)}>
              <span className={styles.productDescription4}>
                {reduxStateLanguage === "RO" ? "Adrese" : "Addresses"}
              </span>
              {getUnderline(2)}
            </div>
          </Link>
          <Link to="/admin/orders">
            <div className={styles.link} style={getTabStyle(3)}>
              <span className={styles.productDescription6}>
                {reduxStateLanguage === "RO" ? "Comenzi" : "Orders"}
              </span>
              {getUnderline(3)}
            </div>
          </Link>

          {isAudioBought && (
            <Link to="/admin/audio_player">
              <div className={styles.link} style={getTabStyle(4)}>
                <span className={styles.productDescription6}>
                  {reduxStateLanguage === "RO"
                    ? "Player Audio"
                    : "Audio Player"}
                </span>
                {getUnderline(4)}
              </div>
            </Link>
          )}
          <button className={styles.button} onClick={handleLogout}>
            <span className={styles.addToCart}>
              {reduxStateLanguage === "RO" ? "Deconectare" : "Log out"}
            </span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
